import HttpService from "./htttp.service";

class PoliciesService {
  // PoliciesEndpoint = process.env.API_URL;

  getPolicies = async () => {
    const getPolicies = "fe/policies";
    return await HttpService.get(getPolicies);
  };

  getPoliciesStats = async () => {
    const getPoliciesStats = "fe/policies/stats";
    return await HttpService.get(getPoliciesStats);
  };

  getPolicySearch = async (payload) => {
    const getPolicySearch = `fe/policies/search?policyName=${payload.policyName}&policyNumber=${payload.policyNumber}&amount=${payload.amount}&insuredItems=${payload.insuredItems}&category=${payload.category}`;
    return await HttpService.get(getPolicySearch, payload);
  };

  getPolicySingle = async (id) => {
    const getPolicySingle = `fe/policies/${id}`;
    return await HttpService.get(getPolicySingle);
  };

  getPoliciesPerCategory = async (id) => {
    const getPoliciesPerCategory = `fe/policies/category/${id}`;
    return await HttpService.get(getPoliciesPerCategory);
  };

  createPolicies = async (payload) => {
    const createPolicies = "fe/policies/new";
    return await HttpService.post(createPolicies, payload);
  };

  editPolicies = async (id, payload) => {
    const editPolicies = `fe/policies/${id}`;
    return await HttpService.put(editPolicies, payload);
  };
}

export default new PoliciesService();
